import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChevronRightComponent } from "./med-icon-chevron-right.component";

@NgModule({
  declarations: [
    MedIconChevronRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChevronRightComponent,
  ],
})
export class MedIconChevronRightModule { }
